module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "x98"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "Spiritual%20Empathy%20flower%20greyscale.tif",
      "src": "image/SpiritualEmpathyflowe_fmt.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "x65"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "Spiritual%20Empathy%20flower%20greyscale.tif",
      "src": "image/SpiritualEmpathyflowe_fmt2.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "glass"
  }, [_c('p', {
    staticClass: "x1pn",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "Anchor"
    }
  }, [_vm._v("Part I")])]), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  }, [_c('p', {
    staticClass: "title--spiritual-power-"
  }, [_vm._v("Foundation")]), _vm._v(" "), _c('p', {
    staticClass: "title--the--and--of-"
  }, [_vm._v("Discovering the Gift of Empathy")])])]), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  }, [_c('div', {
    staticClass: "ding2"
  }, [_c('img', {
    staticClass: "frame-1",
    attrs: {
      "alt": "264.png",
      "src": "image/264.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "part-page-text"
  }, [_vm._v("The excitement of discovery is about to begin! In addition to uncovering new dimensions of empathy, including its profound relationship to compassion and how empathy differs from sympathy, you will learn about the energetic pathways it takes through the physical, emotional, and spiritual layers of your being. You will come to understand that you are literally wired to connect, sense, know, and feel in sync with your highest wisdom. And as you begin to understand your own empathic style more fully in the chapters ahead, your soul will be delighted that you are reclaiming the extraordinary spiritual power known as empathy.")])])]), _c('a', {
    attrs: {
      "id": "Anchor"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08d07c27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SPE-1.vue
// module id = 72
// module chunks = 0